import IllustrationMotion from '@/features/empty-state/IllustrationMotion';
import Link from 'next/link';

function getActionClassName(variant = 'primary') {
  switch (variant) {
    case 'secondary':
      return 'app-button app-button--secondary';
    case 'ghost':
      return 'app-button app-button--ghost';
    case 'primary':
    default:
      return 'app-button app-button--primary';
  }
}

export default function EmptyState({
  eyebrow,
  title,
  titleAs = 'h2',
  message,
  icon = '🫥',
  actionHref,
  actionLabel,
  actionVariant = 'primary',
  className = '',
  tone = 'default',
  role = 'status',
  ariaLabel,
  children,
}) {
  const TitleTag = titleAs;

  return (
    <div
      className={`empty-state ${className}`.trim()}
      role={role}
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <IllustrationMotion icon={icon} tone={tone} />
      {eyebrow ? <p className="empty-state__eyebrow">{eyebrow}</p> : null}
      {title ? (
        <TitleTag className="empty-state__title">{title}</TitleTag>
      ) : null}
      {message ? <p className="empty-state__message">{message}</p> : null}
      {children}
      {actionHref && actionLabel ? (
        <div className="empty-state__actions">
          <Link href={actionHref} className={getActionClassName(actionVariant)}>
            {actionLabel}
          </Link>
        </div>
      ) : null}
    </div>
  );
}
